export default {
    baseUrl: {
        pro: "https://clinic.zhixiayiliao.cn/clinic-prod-api", // 生产环境
        // pro: "http://129.211.190.62:8080/", // 生产环境
        dev: "https://dev.zhixiayiliao.cn/clinictest-stage-api", // 测试环境
        local: 'http://localhost:8080', // 本地开发环境
    },
    //腾讯cos存储地址
    // tencentCosUrl: 'https://tcmms-1320071954.cos.ap-nanjing.myqcloud.com',
    tencentCosUrl: 'https://tcmms-1453384533.cos.ap-beijing.myqcloud.com',
};
